module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/core-js/is-iterable.js
// module id = 618
// module chunks = 11